import { css } from 'lit';
// language=CSS
export default css`
  :host {
    display: flex;
    flex-direction: column;
    padding: 5px 170px 5px 175px;
    position: relative;
    background: rgb(232, 232, 234);
    box-sizing: border-box;
    overflow: auto;
  }

  .main-container {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
    height: auto; 
    box-sizing: border-box;
    overflow: visible;
    margin: 1px 0px;
  }

  /* Top section with Lagebericht and warnings */
  .top-section {
    display: grid;
    grid-template-columns: 2.009fr 1fr;
    gap: 5px;
    width: 100%;
    flex: 0 0 auto; 
    min-height: 0; 
    max-height: 25vh; 
  }

  .lagebericht-section {
    background: white;
    display: flex;
    flex-direction: column;
    border: 1px solid rgb(97, 102, 113);
    min-height: 0; 
    overflow: hidden; 
  }

  .warnings-section {
    display: flex;
    flex-direction: row;
    gap: 5px;
    min-height: 0; 
    overflow: hidden; 
  }

  .warning-item {
    width: 50%;
    background: white;
    display: flex;
    flex-direction: column;
    border: 1px solid rgb(97, 102, 113);
    min-height: 0; 
    overflow: hidden; 
  }

  .warning-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding: 5px;
    min-height: 0; 
  }

  .warning-content img,
  .warning-content svg {
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
    object-fit: contain; 
  }

  /* Maps section - 3 maps side by side */
  .maps-section {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 5px;
    width: 100%;
    flex: 0 0 auto; 
    height: 40vh;
    min-height: 0;
    overflow: visible;
  }

  .map-item {
    background: white;
    display: flex;
    flex-direction: column;
    border: 1px solid rgb(97, 102, 113);
    position: relative;
    min-height: 0; 
    overflow: hidden; 
  }

  /* Aktuelles section at bottom */
  .aktuelles-section {
    background: white;
    display: flex;
    flex-direction: column;
    border: 1px solid rgb(97, 102, 113);
    flex: 0 0 auto;
    min-height: 0; 
    overflow: visible;
  }

  .aktuelles-html > div:first-of-type {
    height: auto !important; 
    overflow: visible;
  }

  .content-wrapper {
    display: block;
    flex: 1;
    width: 100%;
    padding: 10px;
    overflow-y: auto;
    box-sizing: border-box;
    min-height: 0; 
  }

  .lagebericht-section .content-wrapper {
    max-height: calc(100% - 30px);
  }

  .aktuelles-section .content-wrapper {
    max-height: none;
    overflow-y: visible; 
  }

  .titleNode,.titleNodeWarning { 
    color: #fff;
    font-size: medium;
    background-color: #616671;
    padding-left: 3px;
    padding-top: 5px;
    padding-bottom: 5px;
    margin: 0;
    flex: 0 0 auto;
    height: 30px;
    box-sizing: border-box;
  }
  
  .titleNodeWarning {
    font-size: x-small;
  }

  ki-station-map {
    position: absolute;
    top: 30px;
    bottom: 0;
    left: 0;
    right: 0;
    width: initial;
    height: initial;
  }

  .overlay {
    position: absolute;
    z-index: 11;
    top: 30px;
    bottom: 0;
    left: 0;
    right: 0;
    cursor: pointer;
  }

  .leftBorder, .rightBorder {
    background: #e8e8ea;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 170px;
  }

  .leftBorder {
    left: 0;
    width: 175px;
  }

  .rightBorder {
    right: 0;
  }

  /* Desktop responsive */
  @media only screen and (max-width: 1300px) {
    :host {
      padding: 5px 10px;
      background: rgb(232, 232, 234);
    }
    .leftBorder, .rightBorder {
      display: none;
    }
    .maps-section {
      height: 35vh;
    }
  }

  /* Mobile responsive */
  @media only screen and (max-width: 860px) {
    :host {
      padding: 5px 10px;
      background: rgb(232, 232, 234);
      height: auto;
      overflow: visible;
    }

    .main-container {
      height: auto;
      overflow: visible;
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .top-section {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: auto auto;
      flex: none;
      height: auto;
      max-height: none;
      overflow: visible;
    }

    .lagebericht-section {
      min-height: 200px;
      height: auto;
      overflow: visible;
    }

    .warnings-section {
      flex-direction: row;
      gap: 5px;
      height: auto;
      overflow: visible;
    }

    .warning-item {
      min-height: 95px;
      height: auto;
      overflow: visible;
    }

    .content-wrapper {
      max-height: none;
      overflow-y: visible;
    }

    .lagebericht-section .content-wrapper,
    .aktuelles-section .content-wrapper {
      max-height: none;
      overflow-y: visible;
    }

    .warning-content img, .warning-content svg {
      width: 50%;
      height: fit-content;
    }

    .maps-section {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: repeat(3, 1fr);
      flex: none;
      height: auto;
      min-height: 750px;
      overflow: visible;
    }

    .map-item {
      min-height: 250px;
      height: 250px;
      overflow: visible;
    }

    .aktuelles-section {
      flex: none;
      height: auto;
      max-height: none;
      overflow: visible;
      margin-bottom: 4px;
    }

    .aktuelles-html > div:first-of-type {
      height: auto !important;
      overflow: visible;
    }

    .leftBorder, .rightBorder {
      display: none;
    }

    .titleNode, .titleNodeWarning {
      height: auto;
    }
  }

  iframe {
    flex: 1;
    border: 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }
`;